import { DashboardControleDocumentos } from "../../domain/models/dashboard_controle_documentos";
import { IControleDocumentosRepository } from "../../domain/repositories/controle_documentos_repository";
import { IControleDocumentosService } from "../services/controle_documentos_service";

/**
 * ControleDocumentosRepository
 */

export class ControleDocumentosRepository implements IControleDocumentosRepository {
  constructor(private service: IControleDocumentosService) { }

  async getDashboardControleDocumentosInformation(
  ): Promise<DashboardControleDocumentos> {
    const response = await this.service.getDashboardControleDocumentosInformation({});
    return response.item;
  }
}